import NestedFormController from "./nested_form_controller";

// Delivery-zone band editor: nested-form rows whose readonly "from" fields and zone
// numbers are re-derived in cascade — bands stay contiguous by construction while
// typing. Only the last visible row is removable (and never below min rows), so
// zones can only shrink from the tail and the chaining stays intact.
export default class extends NestedFormController {
  static targets = [
    ...NestedFormController.targets,
    "number",
    "minField",
    "maxField",
  ];

  add(event) {
    super.add(event);
    this.rechain();
  }

  remove(event) {
    super.remove(event);
    this.rechain();
  }

  disableButtons() {
    const wrappers = this.visibleWrappers;
    const lastWrapper = wrappers[wrappers.length - 1];

    this.trashButtonTargets.forEach((button) => {
      const wrapper = button.closest(this.wrapperSelectorValue);
      button.disabled = wrappers.length <= this.min || wrapper !== lastWrapper;
    });

    this.hideAddButton();
  }

  initialDisableButtons() {
    this.disableButtons();
  }

  rechain() {
    let runningMin = "0";

    this.visibleWrappers.forEach((wrapper, index) => {
      wrapper.querySelector(
        "[data-delivery-zones-form-target='number']",
      ).textContent = index + 1;
      wrapper.querySelector(
        "[data-delivery-zones-form-target='minField']",
      ).value = runningMin;

      const max = wrapper.querySelector(
        "[data-delivery-zones-form-target='maxField']",
      ).value;
      if (max !== "") runningMin = max;
    });
  }

  // Removed persisted rows are display:none'd by the library; server-rendered
  // _destroy rows carry d-none. Both stay in the DOM and must be skipped.
  get visibleWrappers() {
    return Array.from(
      this.element.querySelectorAll(this.wrapperSelectorValue),
    ).filter(
      (wrapper) =>
        wrapper.style.display !== "none" &&
        !wrapper.classList.contains("d-none"),
    );
  }
}
